"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = create;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _properties = require("../utils/properties");

var _lodash = require("lodash");

var assign = Object.assign,
    getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors,
    keys = Object.keys;
var descriptors = getOwnPropertyDescriptors;

function create(host, propKey) {
  var members = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cacheObject = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cacheKey = "_".concat(propKey);

  if (!host[cacheKey]) {
    (0, _properties.hideProperty)(host, cacheKey, new Map());
  }

  var registryMap = host[cacheKey];
  Object.entries(members).forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    registryMap.set(key, value);
  });
  Object.entries(cacheObject).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    registryMap.set(key, value);
  });
  var resolved = new Map();
  var registry = {
    get: function get(key) {
      return registryMap.get(key);
    },
    has: function has(key) {
      return registryMap.has(key);
    },
    remove: function remove(key) {
      registryMap["delete"](key);
      return registryMap;
    },

    get available() {
      return Array.from(registryMap.keys());
    },

    lookup: function lookup(id) {
      var val = registryMap.get(id);

      if (resolved.has(id)) {
        var found = registryMap.get(id);
        return found;
      }

      if (typeof val === 'function' && !resolved.has(id)) {
        var newVal = val();
        resolved.set(id, true);
        registryMap.set(id, newVal);
        val = newVal;
      }

      return val;
    },
    register: function register(id, value) {
      resolved["delete"](id);
      registryMap.set(id, value);
      return value;
    }
  };
  (0, _properties.hideGetter)(host, propKey, function () {
    return registry;
  });
  return registry;
}

var _default = create;
exports["default"] = _default;